import axios from "axios/index";
import { url } from "../utils/const";
//
// 1) Customer Projects ophalen (direct vanuit Mendix via backend)
//    ✅ nu met REQUEST/SUCCESS/FAILURE zodat UI kan blokkeren tijdens laden
//
export const fetchCustomerProjectsFromMendix = (week, year) => (dispatch) => {

    dispatch({ type: "FETCH_CUSTOMER_PROJECTS_FROM_MENDIX_REQUEST" });

    const token = localStorage.getItem("jwtToken");
    if (!token) {
        const msg = "❌ Geen JWT token gevonden.";
        console.error(msg);

        dispatch({
            type: "FETCH_CUSTOMER_PROJECTS_FROM_MENDIX_FAILURE",
            payload: msg
        });

        return Promise.reject(msg);
    }

    const endpoint =
        url +
        "/api/v1/proxy/mendix/customer-projects" +
        "?Week=" + encodeURIComponent(week) +
        "&Jaar=" + encodeURIComponent(year);

    console.log("🔵 FETCH CUSTOMER-PROJECTS →", endpoint);

    return axios.get(endpoint)
        .then((res) => {
            dispatch({
                type: "FETCH_CUSTOMER_PROJECTS_FROM_MENDIX_SUCCESS",
                payload: res && res.data ? res.data : []
            });
            return res;
        })
        .catch((err) => {
            console.error("❌ Error fetching Mendix customer-projects:", err);

            dispatch({
                type: "FETCH_CUSTOMER_PROJECTS_FROM_MENDIX_FAILURE",
                payload: err
            });

            throw err;
        });
};


//
// 2) Work session opslaan
//    (laat ik zoals jij 'm had; UI-blocking per cel doen we in ProjectCell state)
//
export const addWorkSession = (data) => (dispatch, getState) => {
    return new Promise((accept, reject) => {

        dispatch({ type: "ADD_WORK_SESSION_REQUEST" });

        const user = getState().user.mendixUser;
        if (!user || !user.email) {
            const msg = "❌ Mendix-user of email ontbreekt";
            console.error(msg);

            dispatch({ type: "ADD_WORK_SESSION_FAILURE", payload: msg });
            reject(msg);
            return;
        }

        const loc =
            url +
            "/api/v1/proxy/mendix/work-session" +
            "?Customer=" + encodeURIComponent(data.customer.id) +
            "&Project=" + encodeURIComponent(data.project.id);

        const workSession = {
            numberOfHours: data.time,
            date: data.date,
            description: data.description
        };

        return axios.put(loc, workSession).then(() => {

            // (optioneel) lokale update (jij had die al)
            dispatch({ type: "ADD_WORK_SESSION", payload: data });

            // ✅ unlock alles
            dispatch({ type: "ADD_WORK_SESSION_SUCCESS" });

            accept();

        }).catch((err) => {

            dispatch({ type: "ADD_WORK_SESSION_FAILURE", payload: err });
            reject(err);
        });
    });
};

//
// 3) Alle vakanties ophalen (manager)
//    ✅ typo/fout gefixt en week/year ge-encode
//
export const fetchAllHolidays = (week, year) => (dispatch) => {

    if (!week || !year) {
        console.error("❌ Week/year ontbreken!");
        return Promise.reject("Week/year ontbreken");
    }

    const endpoint =
        url +
        "/api/v1/proxy/mendix/all-holidays" +
        "?Week=" + encodeURIComponent(week) +
        "&Jaar=" + encodeURIComponent(year);

    console.log("🟢 FETCH ALL-HOLIDAYS →", endpoint);

    return axios.get(endpoint)
        .then((res) => {
            dispatch({
                type: "FETCH_ALL_HOLIDAYS",
                payload: res && res.data ? res.data : []
            });
            return res;
        })
        .catch((err) => {
            console.error("❌ Error fetching ALL-HOLIDAYS:", err);
            throw err;
        });
};